<template>
  <div class="o-tooltip o-tooltip--left">
    <button
      type="button"
      class="o-tooltip__icon"
      @click="$emit('infoButtonClicked', $event)"
    >
      <span class="c-elipse">?</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "EclipseButton",
};
</script>
